import { chakra } from "@chakra-ui/react";
import React from "react";

import { route } from "nextjs-routes";

import * as EntityBase from "ui/shared/entities/base/components";

import { distributeEntityProps } from "../base/utils";

type LinkProps = EntityBase.LinkBaseProps & Pick<EntityProps, "number">;

const Link = chakra((props: LinkProps) => {
  const defaultHref = route({
    pathname: "/epochs/[number]",
    query: { number: props.number },
  });

  return (
    <EntityBase.Link {...props} href={props.href ?? defaultHref}>
      {props.children}
    </EntityBase.Link>
  );
});

const Icon = (props: EntityBase.IconBaseProps) => {
  return (
    <EntityBase.Icon
      {...props}
      name={"name" in props ? props.name : "hourglass_slim"}
    />
  );
};

type ContentProps = Omit<EntityBase.ContentBaseProps, "text"> &
  Pick<EntityProps, "number">;

const Content = chakra((props: ContentProps) => {
  return <EntityBase.Content {...props} text={props.number} />;
});

type CopyProps = Omit<EntityBase.CopyBaseProps, "text"> &
  Pick<EntityProps, "number">;

const Copy = (props: CopyProps) => {
  return (
    <EntityBase.Copy
      {...props}
      text={props.number}
      // by default we don't show copy icon
      noCopy={props.noCopy ?? true}
    />
  );
};

const Container = EntityBase.Container;

export interface EntityProps extends EntityBase.EntityBaseProps {
  number: string;
}

const EpochEntity = (props: EntityProps) => {
  const partsProps = distributeEntityProps(props);
  const content = <Content {...partsProps.content} />;

  return (
    <Container {...partsProps.container}>
      <Icon {...partsProps.icon} />
      {props.noLink ? content : <Link {...partsProps.link}>{content}</Link>}
      <Copy {...partsProps.copy} />
    </Container>
  );
};

export default React.memo(chakra(EpochEntity));

export { Container, Link, Icon, Content, Copy };
